var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"logContainer",staticClass:"log-container",style:(_vm.containerStyle),domProps:{"innerHTML":_vm._s(_vm.formattedLogs)}})
}
var staticRenderFns = []

export { render, staticRenderFns }